import FormDialog from '@/components/ui/form-dialog';
import { FunctionComponent, ReactElement } from 'react';
import { UserResponse } from '@/api/users/types';
import { useSendTemporaryPassword } from '@/queries/users';

type User = UserResponse;

interface SendTemporaryPasswordFormProps {
	open: boolean;
	onClose: () => void;
	user?: User;
}

const SendTemporaryPasswordForm: FunctionComponent<SendTemporaryPasswordFormProps> = ({
	open,
	onClose,
	user,
}): ReactElement => {
	const { isLoading, mutate: onSendTemporaryPassword } = useSendTemporaryPassword({
		onSuccess: () => onClose(),
		onError: () => onClose(),
	});

	return (
		<FormDialog
			title="Send temporary password"
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="xs"
			actions={{
				cancel: { label: 'Cancel' },
				confirm: { label: 'Send', isLoading },
			}}
			onSubmit={() => user && onSendTemporaryPassword(user.id)}
		>
			{user &&
				`Send a new temporary password to ${user.firstName} ${user.lastName} (${user.email})? ` +
					'They will be required to set a new password the next time they log in, and the temporary one expires in 48 hours.'}
		</FormDialog>
	);
};

export default SendTemporaryPasswordForm;
